import WebView from "./Web"
import MobileView from "./Mobile"
import { useMediaQuery } from "@mui/material"
export default function BackOffice() {
    const isSmallScreen = useMediaQuery('(max-width:960px)')
    return (
        <>
            {
                isSmallScreen ?
                    <MobileView />
                    :
                    <WebView />
            }
        </>
    )
}